import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";

const TopHeader = () => {
  const { t } = useTranslation();
  // const navigate = useNavigate();

  return (
    <Box className='userlisttophead' sx={{ minHeight: "47px" }}>
      <Typography variant='h3semibold' sx={{ textTransform: "uppercase" }}>
        {t("Role")}
      </Typography>
      {/* <Button
        data-testid='addnew'
        variant='primaryButton'
        onClick={() => navigate("/user-management/user-create")}>
        {t("add_new")}
      </Button> */}
    </Box>
  );
};

export default TopHeader;
